export const ContactUsLang = {
    CONTACT_US: 'CONTACT US',
    QUERIES: 'Comments? Still Having Any Questions?',
    REACH_OUT: 'Feel Free to Reach Out To Us. Now!',
    GET_IN_TOUCH:'Get In Touch',
    NAME: 'Your Name',
    EMAIL: 'Email',
    MESSGAE: 'Message',
    SUBMIT: 'Submit',
    WHAT_WE_ARE: 'WHAT WE ARE?',
    WE_ARE: `We are Digital Parking Tiles manufacturer company.
    Don’t be afraid to contact us we are all here to help you out.`,
    ADDRESS:'Adress',
    ADDRESSVALUE: 'Srv no.555, Morbi-Jetpar Road, Opp. Viratnagar, At Rangpar Morbi-2 (Gujarat) INDIA',
    PHONE1: "+91 96967 55555",
    PHONE2: "+91 75748 55511",
    EMAILVALUE: "lutonceramic@gmail.com",
    CITY: 'City',
    CONTACT: 'Contact',
};